import {HttpBackend, HttpClient} from '@angular/common/http';
import {Injectable, NgZone, inject} from '@angular/core';
import {finalize, timeout} from 'rxjs';
import {buildApiUrl} from '../api/api-url';

export type ScreenLoadOutcome = 'Ready' | 'Error' | 'Canceled';
export interface ScreenLoadDto {
  screenKey: string;
  elapsedMs: number;
  outcome: ScreenLoadOutcome;
  platform: 'Web' | 'Android';
}

@Injectable({providedIn: 'root'})
export class ScreenLoadTransport {
  // An isolated client deliberately avoids auth refresh, compatibility and error dialogs.
  private readonly http = new HttpClient(inject(HttpBackend));
  private readonly zone = inject(NgZone);
  private pending = 0;
  private windowStarted = 0;
  private sent = 0;

  send(event: ScreenLoadDto): void {
    const now = performance.now();
    if (now - this.windowStarted >= 60000) { this.windowStarted = now; this.sent = 0; }
    if (this.pending >= 2 || this.sent >= 60) return;
    this.sent++;
    this.pending++;
    this.zone.runOutsideAngular(() => this.http.post(buildApiUrl('/v1/diagnostics/client-screen-load'), event, {
      headers: {'Content-Type': 'application/json'},
    }).pipe(timeout(5000), finalize(() => this.pending--)).subscribe({error: () => { /* Best effort: drop, without retry or UI effects. */ }}));
  }
}
